/** Persist attachment notices with the message; never embed file contents. */
export function attachmentMessage(message: string, filenames: string[] = []): string {
  const refs = filenames.map(name => name.replace(/[\r\n\0]/g, ' ').trim()).filter(Boolean)
    .map(name => `[REF:file] ${name.includes('/') ? name : `context/${name}`}`);
  return [...refs, message].filter(Boolean).join('\n');
}
